import { Component, Inject, OnDestroy, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { map, startWith } from 'rxjs/operators';
import { UserDAO } from '../../../core/services/dao/userDAO';
import { Payout } from 'anchor-shared/lib/model/entity/payout';
import { FormControl } from '@angular/forms';
import { Observable, Subscription } from 'rxjs';
import { User } from 'anchor-shared/lib/model/entity/user';
import { unsubscribeFromAll } from '../../../core/pure-functions/rx-helper';
import { Charter } from 'anchor-shared/lib/model/entity/charter';
import { CrewMember } from 'anchor-shared/lib/model/entity/crewMember';
import { SubPayout } from 'anchor-shared/lib/model/entity/subPayout';
import { ContainsSubscriptions } from '../../../core/services/interfaces/contains-subscriptions';

@Component({
  selector: 'app-change-payout-payee-dialog',
  templateUrl: './change-payout-payee-dialog.component.html',
  styleUrls: ['./change-payout-payee-dialog.component.scss'],
})
export class ChangePayoutPayeeDialogComponent
  implements OnInit, OnDestroy, ContainsSubscriptions
{
  payout: Payout | SubPayout;
  myControl: FormControl = new FormControl();
  userOptions: any;
  payeeType: string;
  filteredUsers: Observable<User[]>;
  selectedUser: User | Partial<User>;
  lineItemPayees = ['Boat Owner', 'Captain', 'Anchor', 'Specific User'];
  charter: Charter;
  subs: Subscription[] = [];
  crew: PayeeCrewMember[] = [];

  constructor(
    public dialogRef: MatDialogRef<ChangePayoutPayeeDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private userDao: UserDAO,
  ) {
    this.payout = this.data.payout;
    if (this.data.charter) {
      this.charter = this.data.charter;
    }
    if (this.data.crew && this.data.crew.length) {
      this.crew = this.data.crew;
    }
  }

  ngOnInit() {
    const userSub = this.userDao.getUsersForPayouts().subscribe((data) => {
      this.userOptions = data;
      this.filteredUsers = this.myControl.valueChanges.pipe(
        startWith(''),
        map((val) => (val && val.length >= 4 ? this._filter(val) : [])),
      );
    });
    this.subs.push(userSub);
    if (this.crew && this.crew.length) {
      this.crew.forEach((crewMember, index) => {
        this.lineItemPayees.push(
          `Crew ${index + 1} - ${crewMember.user.firstName} ${
            crewMember.user.lastName
          }`,
        );
      });
    }
  }

  _filter(val: string): User[] {
    return this.userOptions.filter((s) =>
      new RegExp(val, 'gi').test(s.firstName + ' ' + s.lastName),
    );
  }

  save() {
    this.dialogRef.close({
      payoutId: this.payout.id,
      user: this.selectedUser,
      payeeType: this.payeeType,
    });
  }

  ngOnDestroy(): void {
    unsubscribeFromAll(this.subs);
  }

  cancel() {
    this.dialogRef.close();
  }

  close(): void {
    this.dialogRef.close(null);
  }

  selectUser(event, user: User) {
    if (event.isUserInput) {
      this.selectedUser = user;
    }
  }

  getUserInfoForSelectedPayee() {
    if (this.payeeType !== 'Specific User') {
      if (this.payeeType === 'Captain') {
        this.selectedUser = this.charter.captain.user;
      } else if (this.payeeType === 'Boat Owner') {
        this.selectedUser = this.charter.boat.owner.user;
      } else if (this.payeeType.startsWith('Crew')) {
        let selectedCrewIndex = parseInt(this.payeeType.charAt(5)) - 1;
        if (!this.crew[selectedCrewIndex].user.id) {
          this.crew[selectedCrewIndex].user.id =
            this.crew[selectedCrewIndex].user.userId;
        }
        this.selectedUser = this.crew[selectedCrewIndex].user;
      }
    }
  }
}

export interface PayoutPayeeSelection {
  payoutId: number;
  user: User;
  payeeType: 'Captain' | 'Boat Owner' | 'Anchor' | 'Crew' | 'Specific User';
}

export interface PayeeCrewMember extends CrewMember {
  user: CrewUser;
}

export interface CrewUser extends User {
  userId?: number;
}
